import { useEffect, useRef } from "react";
import { cn } from "~/lib/utils";

export interface BoundingBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

interface ImageCroppedProps {
  className?: string;
  src: string;
  boundingBox: BoundingBox;
}

const ImageCropped = ({ className, src, boundingBox }: ImageCroppedProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext("2d");

    if (!canvas || !context) return;

    const image = new Image();
    image.src = src;
    image.onload = () => {
      // Set canvas size to the size of the bounding box
      canvas.width = boundingBox.width;
      canvas.height = boundingBox.height;

      // Draw the image cropped to the bounding box
      context.drawImage(
        image,
        boundingBox.x,
        boundingBox.y,
        boundingBox.width,
        boundingBox.height,
        0,
        0,
        boundingBox.width,
        boundingBox.height,
      );
    };
  }, [src, boundingBox]);

  return <canvas ref={canvasRef} className={cn("object-contain", className)} />;
};

export default ImageCropped;
